import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
// ============================================
// top MV news
// ============================================

function slider() {
  const options = {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    pagination: false,
    drag: true,
    snap: true,
    speed: 500,
    easing: 'ease',
    interval: 3000,
    pauseOnHover: false,
    pauseOnFocus: true,
    lazyLoad: 'nearby',
    preloadPages: 2,
    rewind: true,
    // focus: 'center',
    updateOnMove: true,
    breakpoints: {
      640: {
        gap: '8px',
        padding: '0.25rem',
      },
      1024: {
        gap: '12px',
        padding: '0.5rem',
      },
    },
    reducedMotion: {
      speed: 0,
      rewindSpeed: 0,
      autoplay: 'pause',
    },
  };

  const makeOptions = (overrides = {}) => ({
    ...options,
    ...overrides,
    breakpoints: {
      ...options.breakpoints,
      ...overrides.breakpoints,
    },
    reducedMotion: {
      ...options.reducedMotion,
      ...overrides.reducedMotion,
    },
  });

  const wrap = document.querySelectorAll('.js-gallery-slider');
  if (wrap.length === 0) return;

  wrap.forEach((item) => {
    const main = item.querySelector('.splide.p-gallery-slider');
    const archive = item.querySelector('.splide.c-archive01__item-slider');
    const thumb = item.querySelector('.splide.p-gallery-thumbs');

    if (!thumb) return;

    const thumbCount = thumb.querySelectorAll('.splide__slide').length;
    const thumbNum = thumbCount < 3;

    const mainOpt = makeOptions({
      perPage: 1,
      fixedHeight: 780,
      arrows: false,
      breakpoints: {
        960: {
          fixedHeight: false,
        },
      },
    });

    const thumbOpt = makeOptions({
      type: thumbNum ? 'slide' : 'loop',
      perPage: 3,
      fixedHeight: 190,
      isNavigation: true,
      focus: 'center',
      gap: '16px',
      breakpoints: {
        960: {
          fixedWidth: false,
          fixedHeight: false,
          arrows: false,
        },
      },
    });

    if (main) {
      const splide = new Splide(main, mainOpt);
      const thumbs = new Splide(thumb, thumbOpt);

      splide.sync(thumbs);
      splide.mount();
      thumbs.mount();
    }

    if (archive) {
      const archiveOpt = makeOptions({
        perPage: 1,
        arrows: false,
        fixedHeight: 400,
        breakpoints: {
          960: {
            fixedHeight: 360,
          },
        },
      });
      const archiveThumbOpt = makeOptions({
        type: thumbNum ? 'slide' : 'loop',
        perPage: 3,
        fixedHeight: 90,
        isNavigation: true,
        focus: 'center',
        gap: '16px',
        breakpoints: {
          960: {
            arrows: false,
          },
        },
      });

      const splide = new Splide(archive, archiveOpt);
      const thumbs = new Splide(thumb, archiveThumbOpt);

      splide.sync(thumbs);
      splide.mount();
      thumbs.mount();
    }
  });
}

export { slider };
